import Watermark from './Watermark.vue'

// 导出组件
export { Watermark }

// 导出插件
export default {
  install(Vue) {
    Vue.component('Watermark', Watermark)
  }
}